import { useEffect } from 'react';
import { useStartConfig } from './useStartConfig';
import { applyDynamicColors } from '../utils/colorUtils';

export function useDynamicTheme(baseUrl: string = "wwww.aveda.com") {
  const { 
    isLoading, 
    error, 
    data, 
    logo, 
    primaryColor, 
    brandName, 
    brandLabel 
  } = useStartConfig(baseUrl);

  useEffect(() => {
    if (primaryColor && !isLoading) {
      // Applica i colori dinamicamente quando il colore primario è disponibile
      applyDynamicColors(primaryColor);
    }
  }, [primaryColor, isLoading]);

  return {
    isLoading,
    error,
    data,
    logo,
    primaryColor,
    brandName,
    brandLabel,
    isConfigured: !!primaryColor && !!logo
  };
}
